import script from "./ScoreComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreComponent.vue?vue&type=script&setup=true&lang=js"

import "./ScoreComponent.vue?vue&type=style&index=0&id=6d12acc1&lang=scss"

const __exports__ = script;

export default __exports__